import React from 'react';
import { useForceAppUpdate } from '@/hooks';
import { ForceAppUpdateModal } from './force-app-update.modal';

/** Mounted once at the app root; renders nothing outside an outdated WebToNative build. */
export function ForceAppUpdateGate(): React.ReactElement | null {
	const requirement = useForceAppUpdate();
	return requirement ? <ForceAppUpdateModal platform={requirement.platform} /> : null;
}
